import React from "react";
import Header from "../components/sidebar/Header";
import Footer from "../components/sidebar/Footer";
import  SuspenseErrorBoundary  from "../components/config/SuspenseErrorBoundary";

function Layout({children}) {
  return (
    <>
      <Header />
      <SuspenseErrorBoundary>
          {children}
      </SuspenseErrorBoundary>
      <Footer />
    </>
  );
}

export default Layout;
